var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "79px",
    viewBox: "0 0 91 79",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "web-programming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Personal-1-mixed",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-824.000000, -1706.000000)",
    fillRule: "nonzero",
    id: "services"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(350.000000, 1552.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-3",
    transform: "translate(356.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-programming",
    transform: "translate(118.000000, 45.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.1408451,8.64905468 L90.1408451,21.2096106 L0,21.2096106 L0,8.64905468 C0,3.87264796 3.93765024,0 8.79422879,0 L81.3466163,0 C86.2031948,0 90.1408451,3.87264796 90.1408451,8.64905468 Z",
    id: "Path",
    fill: "#F8EC7D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 7.953604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.7303333,0.107413294 C41.5699072,0.113301286 43.0556511,1.57530671 43.0496575,3.3730197 C43.0436276,5.17073247 41.547578,6.6235061 39.7080041,6.61764893 C37.8684302,6.61175645 36.3826864,5.14975082 36.3886799,3.35203783 C36.3955686,1.55432505 37.8907592,0.102390636 39.7303333,0.107413294 Z",
    id: "Path",
    fill: "#E48E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1408451,13.7698765 L90.1408451,61.4646595 C90.1408451,66.2115615 86.2031948,70.0587678 81.3466163,70.0587678 L8.79422879,70.0587678 C3.93765024,70.0587678 0,66.2115615 0,61.4646595 L0,13.7698765 L90.1408451,13.7698765 Z",
    id: "Path",
    fill: "#EEC251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7664034,0.0620811235 C26.6059773,0.0679806856 28.0925799,1.52998632 28.0865864,3.3276991 C28.0805565,5.12541209 26.5845071,6.57818572 24.744933,6.57232854 C22.905359,6.56643585 21.4187564,5.10443022 21.42475,3.30671744 C21.4273447,2.44311033 21.7811747,1.61559159 22.4072484,1.00712206 C23.0341806,0.398652537 23.8835451,0.0587488944 24.7664034,0.0620811235 Z",
    id: "Path",
    fill: "#E48E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.80333224,0.0150821538 C11.6437651,0.0201424413 13.1312263,1.48214808 13.1252329,3.28070007 C13.1200618,5.07925227 11.6240124,6.53286512 9.78357953,6.52700793 C7.94314663,6.52195468 6.45568528,5.05994905 6.46167885,3.26139706 C6.46341474,2.39778973 6.81724482,1.5702712 7.44417726,0.960962248 C8.07110969,0.352492722 8.91961514,0.0117498648 9.80333224,0.0150821538 Z",
    id: "Path",
    fill: "#E48E66"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.5499155,57.0008285 C35.1787636,57.0016765 34.8189645,56.8721384 34.5360157,56.6369246 L24.4109902,48.2220587 C24.0616708,47.9314502 23.8608119,47.50619 23.8608119,47.0587722 C23.8608119,46.6113541 24.0616708,46.1860942 24.4109902,45.8963378 L34.5360157,37.481472 C35.1944829,36.9343439 36.1821838,37.0118961 36.7419685,37.6536214 C37.3026262,38.2961987 37.2240294,39.2600648 36.565562,39.8071928 L27.8404342,47.0587722 L36.5664353,54.3112035 C37.0659621,54.7262369 37.246735,55.4011988 37.0205506,56.0020171 C36.7934929,56.6028356 36.2075094,57.0016765 35.5507888,57.0008285 L35.5499155,57.0008285 Z",
    id: "Path",
    fill: "#D7AD41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5910186,57.0008285 C53.9342538,57.0016793 53.348231,56.6028384 53.1211581,56.0020198 C52.8949585,55.4012014 53.0757435,54.7262394 53.5753039,54.3112059 L62.3010171,47.0587736 L53.5744306,39.8071932 C52.9159191,39.2600651 52.837317,38.2961988 53.3980123,37.6536215 C53.9578343,37.0118961 54.9456015,36.9343438 55.6041131,37.481472 L65.7298179,45.8963391 C66.0791608,46.1860955 66.2800331,46.6113554 66.2800331,47.0587736 C66.2800331,47.5061915 66.0791608,47.9314517 65.7298179,48.2220603 L55.6041131,56.6369273 C55.3211453,56.8721411 54.9621954,57.0008285 54.5910186,57.0008285 L54.5910186,57.0008285 Z",
    id: "Path",
    fill: "#D7AD41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3079856,63.6288318 C40.8436399,63.6288318 40.4050434,63.4240047 40.1123597,63.0722728 C39.8205343,62.7197016 39.7055207,62.2580012 39.8007931,61.8139294 L46.0037999,33.0088576 C46.1788952,32.1954254 46.9942896,31.6758025 47.825992,31.8470514 C48.6568361,32.0183003 49.1889886,32.815783 49.0138931,33.6292152 L42.8108865,62.4342868 C42.6615405,63.1293558 42.034116,63.6279924 41.3079856,63.6288318 L41.3079856,63.6288318 Z",
    id: "Path",
    fill: "#D7AD41"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService2);
export default __webpack_public_path__ + "static/media/service-2.0189a317ca98ff4d0fa0ca26ff3c9244.svg";
export { ForwardRef as ReactComponent };